import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Equal Opportunity Cell" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Equal Opportunity Cell</h3>
                                <p className='caboutus c-lineheight2dot5'>The implementation of various schemes and programmes for the welfare of the disadvantaged and marginalized groups of society and other related activities undertaken by the Institute as well as the implementation of reservation policy in admission and recruitment for SC, ST, PH, OBC (non-creamy layer) and others, if any, the Equal Opportunity Cell of the Institute is constituted with the following members:  </p>

                                {/* <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> */}

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dr. Shihabudheen M. Maliyekkal</p>
                                                <p>Associate Professor</p>
                                            </td>
                                            <td>Chairman</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. N Narasamma</p>
                                                <p>Assistant Professor</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Narendra Singh</p>
                                                <p>Assistant Professor</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Pujari Dinesh Khanna</p>
                                                <p>Technical Superintendent</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mrs. Fathima Azra Fazal</p>
                                                <p>Junior Technical Superintendent</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Mayaram Dhamaniya</p>
                                                <p>EE21B031</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Gagan G.S.</p>
                                                <p>CE23D503</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Ms. Megavarshini M</p>
                                                <p>CH21B027</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. Shafi Ur Rahman Khan</p>
                                                <p>CS21B061</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Mr. Rajan Babu L</p>
                                                <p>Deputy Registrar</p>
                                            </td>
                                            <td>Member Secretary</td>
                                        </tr>
                                        
                                    </tbody>

                                </Table>

                               


                                <h4 className='c-headline caboutus mt-3 mb-3'>The main functions of the cell are:</h4>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To ensure equity and equal opportunity to the community at large in the Institute and bring about social inclusion.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	To enhance the diversity among the Students, Teaching and Non-teaching staff population and at the same time eliminate the perception of discrimination. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	To create a socially congenial atmosphere for academic interaction and for the growth of healthy interpersonal relationships among students coming from various social backgrounds. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	To make efforts to sensitize the academic community regarding the problems associated with social exclusion as well as the aspirations of the marginalized communities.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To help individuals or a group of students belonging to the disadvantaged section of society to contain the problems related to discrimination. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	To look into the grievances of the weaker section of society and suggest amicable solutions to their problems. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To disseminate the information related to schemes and programmes for the welfare of the socially weaker section as well as notifications/memoranda, office orders of the Government, or other related agencies/organizations issued from time to time. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To prepare barrier-free formalities/procedures for admission/ registration of students belonging to the disadvantaged groups of society. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To establish coordination with the Government and other agencies/ organizations to mobilize academic and financial resources to provide assistance to students of the disadvantaged groups. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To organize periodic meetings to monitor the progress of different schemes. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To adopt measures to ensure due share of utilization by SC/ST in Admissions, Recruitment (Teaching and Non-teaching posts) and to improve their performances. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To sensitize the Institute on the problems of SC/ST and other disadvantaged groups. </li>
                                </ul>

                                <h4 className='c-headline caboutus mt-3 mb-3'>Thus, the Centre/Cell shall:</h4>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Oversee/monitor various welfare schemes/ programmes sponsored by the Government of India/State Government, UGC or any agency/ organization as well as those devised by the Institute for the disadvantaged groups for their effective Implementation.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Be responsible for the effective functioning of SC/ST Cell and other such Cells/Centres dealing with the problems of different socially disadvantaged groups </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	Convene the meetings of in-charge of other Committees/Programmes dealing with social issues such as the Gender Sensitization Committee against sexual harassment (GSCASH), National Service Schemes (NSS) etc. to review their activities.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	The Coordinators of SC/ST Cell, Remedial Coaching and other schemes/ Women’s Study Centre, Population Education Cell etc. shall be closely associated with the Equal Opportunity Centre.</li>
                                    
                                </ul>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;